import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useRouteError, useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper } from '@weave-mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
const ErrorPage = () => {
    const error = useRouteError();
    const navigate = useNavigate();
    return (_jsx(Box, { sx: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            bgcolor: 'background.default',
            p: 3,
        }, children: _jsxs(Paper, { elevation: 3, sx: {
                p: 4,
                maxWidth: 600,
                textAlign: 'center',
            }, children: [_jsx(ErrorOutlineIcon, { sx: {
                        fontSize: 64,
                        color: 'error.main',
                        mb: 2,
                    } }), _jsx(Typography, { variant: "h4", gutterBottom: true, children: error?.status === 404 ? 'Page Not Found' : 'Oops! Something went wrong' }), _jsx(Typography, { variant: "body1", color: "text.secondary", paragraph: true, children: error?.statusText || error?.message || 'An unexpected error occurred' }), process.env.NODE_ENV === 'development' && error?.stack && (_jsx(Paper, { variant: "outlined", sx: {
                        p: 2,
                        mt: 2,
                        textAlign: 'left',
                        bgcolor: 'grey.100',
                        maxHeight: 200,
                        overflow: 'auto',
                    }, children: _jsx(Typography, { variant: "caption", component: "pre", sx: { whiteSpace: 'pre-wrap' }, children: error.stack }) })), _jsxs(Box, { sx: { mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }, children: [_jsx(Button, { variant: "contained", onClick: () => navigate(-1), children: "Go Back" }), _jsx(Button, { variant: "outlined", onClick: () => navigate('/'), children: "Go to Home" })] })] }) }));
};
export default ErrorPage;
